import script from "./MainSliderActivities.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainSliderActivities.vue?vue&type=script&setup=true&lang=ts"

import "./MainSliderActivities.vue?vue&type=style&index=0&id=438f364a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438f364a"]])

export default __exports__